import React from 'react';

import { ROUTES } from 'src/constants';
import { BaseLink } from 'src/kit';
import { Dropdown } from 'src/components';
import { composeFullUrl } from 'src/helpers';

export const AuthActions = () => {
  return (
    <>
      <BaseLink href={composeFullUrl(ROUTES.signIn)} mr={30} color="textSecondary" fontSize="16px">
        Sign in
      </BaseLink>
      <Dropdown>
        <Dropdown.Toggle variant="primary" width="103px" height="40px" fontSize="16px" size="sm">
          Sign up
        </Dropdown.Toggle>
        <Dropdown.Menu minWidth={150} color="textSecondary">
          <Dropdown.Item>
            <BaseLink href={composeFullUrl(ROUTES.signUpCandidate)}>As a candidate</BaseLink>
          </Dropdown.Item>
          <Dropdown.Item>
            <BaseLink href={composeFullUrl(ROUTES.signUpEmployer)}> As an employer</BaseLink>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
